import {
  COMPLETED,
  IN_PROGRESS,
  PENDING,
} from '../../../constants/reviewStatuses';

export const getStatusIcon = (reviewStatus) => {
  switch (reviewStatus) {
    case PENDING:
    case IN_PROGRESS:
      return <span className='status-icon'>P</span>;
    case COMPLETED:
      return <span className='status-icon status-icon-completed'>C</span>;
    default:
      return null;
  }
};
